import { diff } from 'deep-object-diff';
import { MicroTaskConfig } from '../classes/micro-task/micro-task-config';
import { removeUndefinedProps } from './remove-undefined-props';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function removeKeys(object: any, keysToRemove: string[]): void {
	for (const key of Object.keys(object)) {
		if (keysToRemove.includes(key)) {
			delete object[key];
		} else if (object[key] !== null && typeof object[key] === 'object') {
			removeKeys(object[key], keysToRemove);
			if (Object.keys(object[key]).length === 0) {
				delete object[key];
			}
		}
	}
}

export const checkTaskForChanges = (
	originalMicroTaskTemp: MicroTaskConfig,
	microTask: MicroTaskConfig,
	isUserInputChange?: boolean
) => {
	// deep-object-diff returns live references (not clones) for anything added/changed, so clone
	// before the destructive removeKeys/removeUndefinedProps calls below - otherwise they mutate
	// the actual live MicroTaskConfig/AddItemField state in place.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const microTaskChanges: any = JSON.parse(JSON.stringify(diff(originalMicroTaskTemp, microTask)));
	//We need to remove the objectState from any level of nesting in the changes as this is not a real change but just a marker for the frontend
	removeKeys(microTaskChanges, ['objectState']);
	if (Object.hasOwn(microTaskChanges, 'config')) {
		removeUndefinedProps(microTaskChanges['config']);
	}
	removeUndefinedProps(microTaskChanges);

	const changeKeys = Object.keys(microTaskChanges);
	if (changeKeys.length === 1 && !isUserInputChange && changeKeys[0] === 'sampleData') {
		return undefined;
	}
	return changeKeys;
};
